import { RegistryFieldsType } from '@rjsf/utils'
import { GalleryImageSelector } from '.'

export const galleryImageSelectorFieldRegistry: RegistryFieldsType = {
    galleryImageSelector: GalleryImageSelector
}
